import axios from "axios";
import { endpoints } from "../_config";

class OpenService {
  static async getFontData() {
    return axios
      .get(endpoints.open.getFontData, {})
      .then((response) => response.data);
  }

  static async getLinkMetaData(url) {
    return axios
      .get(endpoints.open.getLinkMeta(url))
      .then((response) => response.data);
  }
}

export { OpenService };
